import React, { useState, useEffect } from 'react';
import { Redirect, useLocation } from "react-router-dom";

import { Spin, Typography, notification } from 'antd';

import _auth from '@netuno/auth-client';
import _service from '@netuno/service-client';

import MarketplaceServicePage from './Marketplace/Service';
import MarketplaceWastePage from './Marketplace/Waste';
import ServicePage from './Service';
import ConstructionList from './Construction/ConstructionList';
import ConstructionEdit from './Construction/ConstructionEdit';
import WasteToConsumePage from './Waste/ToConsume';
import WasteToProducePage from './Waste/ToProduce';

import Core from '../../common/Core';

import './index.less';

const { Title } = Typography;

export default (props) => {
    const [ loading, setLoading ] = useState(false);
    useEffect(()=> {
        if (Core.info() == null) {
            setLoading(true);
            _service({
                method: 'GET',
                url: 'client',
                success: (response) => {
                    if (response.json.result) {
                        Core.info(response.json.data);
                        console.log(response.json.result);
                        window.setTimeout(() => { window.location.reload(); }, 250);
                    } else {
                        notification["warning"]({
                            message: 'Ocorreu um erro a carregar os dados',
                            description: response.json.error,
                        });
                        setLoading(false);
                    }
                },
                
                fail: () => {
                    setLoading(false);
                    notification["error"]({
                        message: 'Ocorreu um erro a carregar os dados',
                        description: 'Ocorreu um erro a carregar os dados, por favor tente novamente.',
                    });
                }
            });
        }
        
    },  []);
    if (loading) {
        return (
            <div className="dashboard-layout-content">
              <div className="dashboard-loading"><Spin size="large"/></div>
            </div>
        );
    }
    if (_auth.isLogged()) {
        const location = useLocation();
        if (location.pathname.indexOf('/construction/edit/') == 0) {
            return <ConstructionEdit {...props}/>;
        } else {
            switch (location.pathname) {
            case '/marketplace/service':
                return <MarketplaceServicePage {...props}/>;
            case '/marketplace/waste':
                return <MarketplaceWastePage {...props}/>;
            case '/service':
                return <ServicePage {...props}/>;
            case '/construction/list':
                return <ConstructionList {...props}/>;
            case '/construction/create':
                return <ConstructionEdit {...props}/>;
            case '/waste/to-consume':
                return <WasteToConsumePage {...props}/>;
            case '/waste/to-produce':
                return <WasteToProducePage {...props}/>;
            }
        }
        return (
            
            <div className="dashboard-layout-content">
                <Title level={2}>Olá!</Title>
                <Title level={3} style={{ marginTop: 0 }}>Bem-vindo(a) à sua Área Reservada!</Title>
                <img alt="reserved-area" src={"/images/reserved-area.png"} />
            </div>
        );
    } else {
        return <Redirect to="/login" />;
    }
}
